import { initScrollLottie } from '../helpers/lottie';
import { scaleBlockToScreen } from '../helpers/video-helpers';

export default () => {
	const section = document.querySelector('.js-touch-section');
	const wrapper = document.querySelector('.js-touch-section-lottie-wrapper');
	const lottieEl = document.querySelector('.js-touch-section-lottie');
	if(!wrapper || !lottieEl) return;

	initScrollLottie(lottieEl, {
		autoplay: true,
		loop: true
	});

	scaleBlockToScreen(wrapper, 'absolute', section);
};
